<div class="container" style="height: 100vh">
  <div class="d-flex justify-content-center align-items-center h-100">
    <mat-card class="p-4">
      <form [formGroup]="form" autocomplete="off">
        <mat-card-header>
          <mat-card-title>Sign In Account</mat-card-title>
        </mat-card-header>
        <mat-card-content class="mt-4">
          <div class="d-flex flex-column gap-4" style="width: 15em">
            <mat-form-field appearance="outline">
              <mat-label>Username</mat-label>
              <input
                autocomplete="off"
                formControlName="username"
                matInput
                placeholder="Username"
              />
              <mat-error *ngIf="form.get('username')?.hasError('required')" class="mt-1">
                Username cannot be blank
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Password</mat-label>
              <input
                autocomplete="off"
                formControlName="password"
                matInput
                placeholder="Password"
                type="password"
              />
              <mat-error *ngIf="form.get('password')?.hasError('required')" class="mt-1">
                Password cannot be blank
              </mat-error>
            </mat-form-field>
          </div>
        </mat-card-content>
        <mat-card-actions align="end" class="mt-2">
          <button (click)="onClickSignIn()" color="primary" mat-raised-button type="submit">Sign In</button>
        </mat-card-actions>
      </form>
    </mat-card>
  </div>
</div>
